// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-wrapper[data-v-7d32a3f8]{border-top:1px solid #d7dfe1}@media screen and (max-width:767px){.product-wrapper[data-v-7d32a3f8]{background-color:#f3f6f8;margin-left:-15px!important;margin-right:-15px!important;padding:10px 0}.faq-button[data-v-7d32a3f8]{width:100%!important}.header-margin h2[data-v-7d32a3f8]{margin-top:1.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
